// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import NodeExpandOutlinedSvg from "@fishx/icons-svg/es/asn/NodeExpandOutlined";
import FishxIcon from '../components/FishxIcon';

var NodeExpandOutlined = function NodeExpandOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: NodeExpandOutlinedSvg
  }));
};

NodeExpandOutlined.displayName = 'NodeExpandOutlined';
export default React.forwardRef(NodeExpandOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/NodeExpandOutlined.js
// module id = 3165
// module chunks = 0